import axios from "axios";

const graphqlUrl =
  process.env.VUE_APP_GRAPHQL_HTTP ||
  "https://livestock-api-gateway-dev.dimitra.dev/graphql";
// const graphqlUrl =   'http://localhost:3000/graphql'

export default {
  async addFarm(data) {
    return await axios
      .post("/farm", data)
      .then((result) => result.data)
      .catch((error) => Promise.reject(error));
  },
  async loadoptions(data) {
    return await axios
      .post("/option", data)
      .then(({ data }) => data)
      .catch((error) => Promise.reject(error));
  },
  async loadUsers() {
    return await axios
      .get("/option/user?page=1&limit=1000")
      .then(({ data }) => data)
      .catch((error) => Promise.reject(error));
  },
  async loadCountries() {
    return await axios
      .get("/option/country")
      .then((data) => data.data)
      .catch((error) => Promise.reject(error));
  },
  async loadStates(id) {
    let url = `/option/state?country=${id}`;
    return await axios
      .get(url)
      .then((data) => data.data)
      .catch((error) => Promise.reject(error));
  },
  async loadCities(id) {
    let url = `/option/city?state=${id}`;
    return await axios
      .get(url)
      .then((data) => data.data)
      .catch((error) => Promise.reject(error));
  },
  async getfarms(dataOptions, search) {
    var url = `/farm?page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`;
    if (search != "") url = `${url}&search=${search}`;
    if (dataOptions.sortBy.length)
      url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => Promise.reject(error));
  },
  async getfarm(id) {
    var url = `farm/${id}`;
    return await axios
      .get(url)
      .then(({ data }) => data.data)
      .catch((error) => Promise.reject(error));
  },
  async editfarm(data) {
    var url = `farm/`;
    return await axios
      .put(url, data)
      .then((result) => result.data)
      .catch((error) => Promise.reject(error));
  },

  async searchFarms(search = "") {
    var url = "/option/farm/list?page=1&limit=1000";
    if (search.length > 0) url = `${url}&search=${search}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => Promise.reject(error));
  },
  async searchUsers(search = "") {
    var url = "/option/user?page=1&limit=1000";
    if (search.length > 0) url = `${url}&search=${search}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => Promise.reject(error));
  },

  //  New Changes

  async getFarmers() {
    try {
      const { data } = await axios.get("/farm/select-farmers");
      return Promise.resolve(data.data);
    } catch {
      return Promise.resolve([]);
    }
  },

  async getFarmOptions() {
    try {
      const { data } = await axios.post("/list/options", {
        options: ["FarmProductionSystem", "FarmTypes", "farm-ownership-type"],
      });
      return Promise.resolve(data.data);
    } catch {
      return Promise.resolve([]);
    }
  },

  async getPrimaryFarm() {
    try {
      const token = localStorage.getItem("token");
      console.log(token, "token from service");
      let result = await axios({
        url: graphqlUrl,
        headers: {
          authorization: token,
        },
        method: "post",
        data: {
          query: `
                  query {
                    primaryFarm {
                      id
                      farmName
                      registrationNo
                      lat
                      log
                      address
                      area
                      areaUomId
                      parameter
                      parameterUomId
                      farmOwnershipType
                      farmType
                      productionSystem
                      farmOwner
                      userId
                      country
                      state
                      city
                      govRegistrationNum
                      contractMating
                      cooperativeId
                      cooperativeName
                      licenceNum
                      licenceExpiryDate
                      regulatorName
                      houseNum
                      street
                      regulatorRepresentiveName
                      isDeleted
                      farmingActivity
                      farmNumber
                      communityName
                      corporateName
                      corporateRegistrationNum
                      corporateMailingAddress
                      FarmCoordinates {
                        id
                        lat
                        log
                      }
                      GeoFences {
                        id
                        geofenceName
                        geofenceArea
                        geofenceAreaUOMId
                        geofenceParameter
                        geofenceCoordinates {
                          id
                          lat
                          log
                        }
                      }
                      farmTypeAssoc {
                        id
                        name
                      }
                  
                      userAssoc {
                        id
                      }
                      productionSystemAssoc {
                        id
                        name
                      }
                      createdAt
                    }
                  }
                  
                    `,
        },
      });
      let data = result.data.data.primaryFarm;
      data.fullName = `${data.firstName} ${data.lastName}`;

      data.createdAt = data.createdAt.split("T")[0];
      console.log(result, "result");
      return { data };
    } catch (e) {
      return {};
    }
  },

  async getPrimaryFarmId() {
    try {
      const token = localStorage.getItem("token");
      console.log(token, "token from service");
      let result = await axios({
        url: graphqlUrl,
        headers: {
          authorization: token,
        },
        method: "post",
        data: {
          query: `
                  query {
                    primaryFarm {
                      id
                    }
                  }
               `,
        },
      });
      let id = result.data.data.primaryFarm.id;
      return id ;
    } catch (e) {
      return {};
    }
  },

  async getFarm(farmId) {
    try {
      const token = localStorage.getItem("token");
      console.log(token, "token from service");
      let result = await axios({
        url: graphqlUrl,
        headers: {
          authorization: token,
        },
        method: "post",
        data: {
          query: `
             {
                    farm(id: ${farmId}) {
                      id
                      farmName
                      registrationNo
                      lat
                      log
                      address
                      area
                      areaUomId
                      parameter
                      parameterUomId
                      farmOwnershipType
                      farmType
                      productionSystem
                      farmOwner
                      userId
                      country
                      state
                      city
                      govRegistrationNum
                      contractMating
                      cooperativeId
                      cooperativeName
                      licenceNum
                      licenceExpiryDate
                      regulatorName
                      houseNum
                      street
                      regulatorRepresentiveName
                      isDeleted
                      farmingActivity
                      farmNumber
                      communityName
                      corporateName
                      corporateRegistrationNum
                      corporateMailingAddress
                      FarmCoordinates {
                        id
                        lat
                        log
                      }
                      GeoFences {
                        id
                        geofenceName
                        geofenceArea
                        geofenceAreaUOMId
                        geofenceParameter
                        geofenceCoordinates {
                          id
                          lat
                          log
                        }
                      }
                      farmTypeAssoc {
                        id
                        name
                      }
                  
                      userAssoc {
                        id
                        firstName
                        lastName
                      }
                      productionSystemAssoc {
                        id
                        name
                      }
                      createdAt
                    }
                  }
                  
                    `,
        },
      });
      let data = result.data.data.farm;
      data.fullName = `${data.firstName} ${data.lastName}`;

      data.createdAt = data.createdAt.split("T")[0];
      console.log(result, "result");
      return { data };
    } catch (e) {
      return {};
    }
  },

  async updateFarmSegments(gdata, create = true) {
    const url = "/farm/segment";
    var d;
    try {
      if (create) d = await axios.post(url, gdata);
      else d = await axios.put(url, gdata);

      return Promise.resolve(d.data);
    } catch (e) {
      return Promise.reject({});
    }
  },

  async getFarmZones() {
    try {
      const { data } = await axios.get("/farm/segment/", {
        params: {
          page: 1,
        },
      });
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject({});
    }
  },

  async deleteFarm(rdata) {
    try {
      const { data } = await axios.delete("/farm", {
        data: rdata,
      });
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject({});
    }
  },

  async getZoneGeofence(geoFenceId) {
    try {
      const token = localStorage.getItem("token");
      console.log(token, "token from service");
      let result = await axios({
        url: graphqlUrl,
        headers: {
          authorization: token,
        },
        method: "post",
        data: {
          query: `
                  query geofence($id: Int!) {
                    geofence(id: $id) {                      
                        id
                        geofenceName
                        geofenceArea
                        geofenceAreaUOMId
                        geofenceParameter
                        geofenceCoordinates {
                          id
                          lat
                          log
                        }
                      }
                    }`,
          variables: {
            id: geoFenceId,
          },
        },
      });
      let data = result.data.data.geofence;
      console.log(result, "result");
      return { data };
    } catch (e) {
      return {};
    }
  },

  async getfarmLocations(farmId) {
    try {
      const token = localStorage.getItem("token");
      console.log(token, "token from service");
      let result = await axios({
        url: graphqlUrl,
        headers: {
          authorization: token,
        },
        method: "post",
        data: {
          query: `
                query farmLocations($farmId: Float!) {
                    (farmId: $farmId) {
                    id
                    address
                    area
                    city
                    areaUomId
                    country                    
                    farmNumber
                    lat
                    log
                    parameter
                    state
                    street
                    userId
                    farmId
                    isDeleted
                  }
                }`,
          variables: {
            farmId: farmId,
          },
        },
      });
      let data = result.data.data.farmLocations;
      return { data };
    } catch (e) {
      return {};
    }     
  },

  async getLocationData(farmId, id) {
    try {
      const token = localStorage.getItem("token");
      console.log(token, "token from service");
      let result = await axios({
        url: graphqlUrl,
        headers: {
          authorization: token,
        },
        method: "post",
        data: {
          query: `
          query farmLocation($farmId: Float!, $id: Int!) {
            farmLocation(farmId: $farmId, id: $id) {
              id
              address
              area
              city
              areaUomId
              country
              GeoFences {
                id
                geofenceName
                geofenceArea
                geofenceParameter
                geofenceParameterUOMId
                geofenceCoordinates{
                  id
                  lat
                  log
                }
              }
              farmNumber
              lat
              log
              parameter
              state
              street
              userId
              farmId
              isDeleted
            }
          }`,
          variables: {
            farmId: farmId,
            id: id,
          },
        },
      });
      let data = result.data.data.farmLocation;
      return { data };
    } catch (e) {
      return {};
    }     
  },

  async getZonesByLocationId(locationId, search, page, limit) {
    try {
      const token = localStorage.getItem("token");
      console.log(token, "token from service");
      let result = await axios({
        url: graphqlUrl,
        headers: {
          authorization: token,
        },
        method: "post",
        data: {
          query: `
            query zoneByLocationId($locationId: Int!, $search: String, $page: Float, $limit: Float) {
              zoneByLocationId(locationId: $locationId, search: $search, page: $page, limit: $limit) {
                id
                geofenceName
                geofenceArea
                geofenceAreaUOMId
                geofenceParameter
                geofenceParameterUOMId
                walkAndMeasure
                geofenceCoordinates {
                  id
                  lat
                  log
                }
              }
            }
          `,
          variables: {
            locationId: locationId,
            search: search,
            page: page,
            limit: limit,
          },
        },
      });
      let data = result.data.data.zoneByLocationId;
      return { data };
    } catch (e) {
      return {};
    }
  },

  async getAllZonesByLocationId(locationId) {
    try {
      const token = localStorage.getItem("token");
      console.log(token, "token from service");
      let result = await axios({
        url: graphqlUrl,
        headers: {
          authorization: token,
        },
        method: "post",
        data: {
          query: `
            query allZonesByLocationId($locationId: Int!) {
              allZonesByLocationId(locationId: $locationId) {
                id
                geofenceName
                geofenceArea
                geofenceAreaUOMId
                geofenceParameter
                geofenceParameterUOMId
                walkAndMeasure
                geofenceCoordinates {
                  id
                  lat
                  log
                }
              }
            }
          `,
          variables: {
            locationId: locationId,
          },
        },
      });
      let data = result.data.data.allZonesByLocationId;
      return { data };
    } catch (e) {
      return {};
    }
  },


  async primaryFarmLocation(farmId) {
    try {
      const token = localStorage.getItem("token");
      console.log(token, "token from service");
      let result = await axios({
        url: graphqlUrl,
        headers: {
          authorization: token,
        },
        method: "post",
        data: {
          query: `
          query primaryFarmLocation($farmId: Float!) {
            primaryFarmLocation(farmId: $farmId) {
              id
              address
              area
              city
              areaUomId
              country
              GeoFences {
                id
                geofenceName
                geofenceArea
                geofenceParameter
                geofenceParameterUOMId
                geofenceCoordinates{
                  id
                  lat
                  log
                }
              }
              farmNumber
              lat
              log
              parameter
              state
              street
              userId
              farmId
              isDeleted
            }
          }`,
          variables: {
            farmId: farmId,
          },
        },
      });
      let data = result.data.data.primaryFarmLocation;
      return { data };
    } catch (e) {
      return {};
    }     
  },
};
